import React from 'react';

function DevelopersPage() {
    return <div>Developers Page</div>;
}

export default DevelopersPage;
